import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { useTextField } from './hooks/use-text-field';
import { FieldWrap } from './field-wrap';
import styles from './styles.module.css';

export const TextAreaField = (props) => {
  const { name, rows } = props;
  const { t } = useTranslation();

  const [value, { hasError, handleOnChange, handleBlur, error }] =
    useTextField(name);

  return (
    <FieldWrap name={name} hasError={hasError} error={error}>
      <Input.TextArea
        value={value}
        placeholder={t(`field.${name}.placeholder`)}
        onChange={handleOnChange}
        onBlur={handleBlur}
        className={styles.input}
        name={name}
        rows={rows}
      />
    </FieldWrap>
  );
};
